module.exports = __webpack_public_path__ + "fonts/SFProText-Semibold.f9ef2989.woff";